import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import constant from '@constants/constant'
import endpoint from '@constants/apipath'
import common from '@state/modules/common'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  fetchScoreReport({ commit, dispatch, getters }, payload) {
    const url = `${appConfig.apiEndPoint}${
      endpoint.reportApiPath.getscorereport
    }`

    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchCustomer({ state }, { pageNumber, pageSize } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.getcustomers
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&isActive=1&key=CustomerType&value=customer`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  downloadScoreReport({ commit, dispatch, getters }, payload) {
    const url = `${appConfig.apiEndPoint}${
      endpoint.reportApiPath.downloadscorereport
    }`

    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        let fromDate = common.getDatepart(payload.fromDate)
        let toDate = common.getDatepart(payload.toDate)

        let reportName = ''
        reportName = `${
          constant.downloadScoreReportName
        }_${fromDate}_${toDate}.csv`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, reportName)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', reportName)
          document.body.appendChild(link)
          link.click()
        }

        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
